import defaultClient from '@src/api/clients/default';

export function fetchOptimizerRuns(params = {}) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/runs/',
    method: 'GET',
    options: { params },
  });
}

export function fetchOptimizerRunDetail(runId) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/`,
    method: 'GET',
  });
}

export function approveOptimizerRun(runId) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/approve/`,
    method: 'POST',
  });
}

export function rejectOptimizerRun(runId, notes = '') {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/reject/`,
    method: 'POST',
    payload: { notes },
  });
}

export function fetchOptimizerRunChanges(runId) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/changes/`,
    method: 'GET',
  });
}

export function fetchOptimizerConfigs(params = {}) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/configs/',
    method: 'GET',
    options: { params },
  });
}

export function createOptimizerConfig(data) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/configs/',
    method: 'POST',
    payload: data,
  });
}

export function updateOptimizerConfig(configId, data) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/configs/${configId}/`,
    method: 'PATCH',
    payload: data,
  });
}

export function triggerOptimizerRun(clientId) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/trigger/',
    method: 'POST',
    payload: { client_id: clientId },
  });
}
